import z from "zod";

export const locationSchema = z.object({
  latitude: z.number(),
  longitude: z.number(),
  xyClass: z.number(),
});

export const addressSchema = z.object({
  city: z.string(),
  cityDistricted: z.string(),
  county: z.string(),
  houseNumber: z.string(),
  location: locationSchema,
  municipality: z.string(),
  state: z.string(),
  street: z.string(),
  street1: z.string(),
  streetPrefix: z.string(),
  streetTeryt: z.string(),
  uuid: z.string(),
  zip: z.string(),
});

export const fetchAddressesResponseSchema = z
  .object({
    addresses: z.array(addressSchema),
  })
  .transform((data) => data.addresses);
